import {HistoryMessage} from "../../types/chat";

export class ChatHistoryHandler {

    public handleSendHistoryRequest = (chatWebSocket: WebSocket|null, historyMessage: HistoryMessage, onError: () => void): void =>
    {
        if (chatWebSocket === null) {
            return;
        }

        chatWebSocket.send(JSON.stringify(historyMessage));
    }
}